__turbopack_context__.v({
  "accordionSlideOverwrite": "toast-module-scss-module__6_-gFa__accordionSlideOverwrite",
  "closeIcon": "toast-module-scss-module__6_-gFa__closeIcon",
  "description": "toast-module-scss-module__6_-gFa__description",
  "error": "toast-module-scss-module__6_-gFa__error",
  "fadeIn": "toast-module-scss-module__6_-gFa__fadeIn",
  "fadeOut": "toast-module-scss-module__6_-gFa__fadeOut",
  "icon": "toast-module-scss-module__6_-gFa__icon",
  "info": "toast-module-scss-module__6_-gFa__info",
  "noDescription": "toast-module-scss-module__6_-gFa__noDescription",
  "scaleIn": "toast-module-scss-module__6_-gFa__scaleIn",
  "scaleOut": "toast-module-scss-module__6_-gFa__scaleOut",
  "success": "toast-module-scss-module__6_-gFa__success",
  "textContent": "toast-module-scss-module__6_-gFa__textContent",
  "title": "toast-module-scss-module__6_-gFa__title",
  "toast": "toast-module-scss-module__6_-gFa__toast",
  "warning": "toast-module-scss-module__6_-gFa__warning",
  "zoomIn": "toast-module-scss-module__6_-gFa__zoomIn",
  "zoomOut": "toast-module-scss-module__6_-gFa__zoomOut",
});
